import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const expensesClaimTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "expenses.claim-trend",
  name: "Claim volume",
  description: "Claim volume across the selected period.",
  apps: [
    "home",
    "expenses",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "expenses.records",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "expense_id",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Claims",
        query: {
          version: 1,
          source: "expenses.records",
          ...period(30),
          select: [
            {
              type: "field",
              field: "expense_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "count_distinct",
              field: "expense_id",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "expense_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Claim volume",
    valueFormat: "number",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "84",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
